import React, { useState, useContext, useEffect } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';

import PageWrapper from 'src/layout/PageWrapper/PageWrapper';
import Page from 'src/layout/Page/Page';
import Humans from 'src/assets/img/scene4.png';
import HumansWebp from 'src/assets/img/scene4.webp';
import { demoPagesMenu, dashboardPagesMenu } from 'src/menu';
import { useTranslation } from 'react-i18next';

import { CardFooter, CardFooterLeft, CardFooterRight } from 'src/components/bootstrap/Card';
import Pagination, { PaginationItem } from 'src/components/bootstrap/Pagination';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import Card, { CardBody } from 'src/components/bootstrap/Card';
import { useSelector } from 'react-redux';
import { getRole } from 'src/redux/slices/user';

import Icon from 'src/components/icon/Icon';
import {
	BsWallet2,
	BsArrowBarUp,
	BsArrowBarDown,
	BsSearch,
	BsArrowClockwise,
	BsBoxFill,
} from 'react-icons/bs';

import { PaymentServices } from 'src/services/PaymentServices';
import ThemeContext from 'src/contexts/themeContext';
import useDeviceScreen from 'src/hooks/useDeviceScreen';
import TablePagination from '@mui/material/TablePagination';
import showNotification from 'src/components/extras/showNotification';
import ModalDetail from 'src/pages/presentation/dashboard/ModalDetail';
import ModalDeposit from './ModalDeposit';
import MoDalQrcode from './MoDalQrcode';

export const PER_COUNT = {
	10: 10,
	20: 20,
	50: 50,
	100: 100,
};

export default function UplineSummary() {
	const role = useSelector(getRole);
	const { t } = useTranslation();
	const { asideStatus } = useContext(ThemeContext);
	const { width } = useDeviceScreen();

	const [totalAmount, setTotalAmount] = useState([]);

	const [Foundin, setFoundIn] = useState([]);
	const [meta, setMeta] = useState();
	const [perPage, setPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);

	const [totalItems, setTotalItems] = useState(0);
	const [totalPage, setTotalPage] = useState(0);

	const [tranRef, setTranRef] = useState('');
	const [timeQuery, setTimeQuery] = useState([
		moment().startOf('month'),
		moment().endOf('month'),
	]);
	const [status, setStatus] = useState('');
	const [dataCard, setDataCard] = useState([]);

	const handleEvent = (event, picker) => {
		console.log('handleEvent : ', moment(picker.startDate).format('DD/MM/YYYY'));
	};

	const handleCallback = (start, end, label) => {
		setTimeQuery([moment(start), moment(end)]);
	};

	const handleRefresh = () => {
		fetchDownLine();
		showNotification(
			<span className='d-flex align-items-center'>
				{/* <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
                <span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span> */}
			</span>,
			`${t('txt_the_latest_information')}`,
		);
	};

	const handleSearch = () => {
		fetchDownLine();
	};

	const fetchDownLine = () => {
		let payload = {
			dateStart: timeQuery[0].format('YYYY/MM/DD'),
			dateEnd: timeQuery[1].format('YYYY/MM/DD'),
			page: currentPage,
			limit: perPage,
		};
		if (role === 'admin') {
			PaymentServices.getUplineSummary(payload)
				.then(({ data }) => {
					setTotalAmount(data?.summary);
					// console.log('================================');

					// console.log('DATA UplineSummary ADMIN : ', data);

					// console.log('================================');

					const arr1 = [
						{
							name: `${t('txt_total_number_of_items')}`,
							balance: data?.summary?.qty,
							color: '#EE1F41',
							icon: <BsBoxFill />,
						},
					];

					const arr2 = [
						{
							name: `${t('txt_customer_balance')}`,
							balance: data?.summary?.downline_amount,
							color: '#EE1F41',
							icon: <BsArrowBarUp />,
						},
					];
					const arr3 = [
						{
							name: `${t('txt_system_balance')}`,
							balance: data?.summary?.upline_amount,
							color: '#EE1F41',
							icon: <BsArrowBarDown />,
						},
					];

					const arr4 = [
						{
							name: `${t('txt_net_amount')}`,
							balance: data?.summary?.amount,
							color: '#238FE9',
							icon: <BsWallet2 />,
						},
					];

					const newArr = [...arr1, ...arr2, ...arr3, ...arr4];
					setDataCard(newArr);

					setFoundIn(data?.items);
					setTotalItems(data?.total);
					setTotalPage(data?.last_page);

					setMeta({ totalItems: data.total });
				})
				.catch((err) => {
					console.log(err);
				});
		}
	};

	const getInfo = () => {
		const start = perPage * (currentPage - 1) + 1;

		const end = perPage * currentPage;

		return (
			<span className='pagination__desc'>
				{t('txt_showing')} {start} {t('txt_to')} {end > totalItems ? totalItems : end}{' '}
				{t('txt_of')} {totalItems} {t('txt_list')}
			</span>
		);
	};

	const pagination = () => {
		let items = [];

		let i = currentPage - 1;
		while (i >= currentPage - 1 && i > 0) {
			items.push(
				<PaginationItem key={i} onClick={() => setCurrentPage(currentPage - 1)}>
					{i}
				</PaginationItem>,
			);

			i -= 1;
		}

		items = items.reverse();

		items.push(
			<PaginationItem key={currentPage} isActive onClick={() => setCurrentPage(currentPage)}>
				{currentPage}
			</PaginationItem>,
		);

		i = currentPage + 1;
		while (i <= currentPage + 1 && i <= totalPage) {
			items.push(
				<PaginationItem key={i} onClick={() => setCurrentPage(currentPage + 1)}>
					{i}
				</PaginationItem>,
			);

			i += 1;
		}

		return items;
	};

	const convertDate = (data) => {
		const convert = moment(data).format('DD/MM/YYYY - HH:mm:ss');
		return convert;
	};

	const ccyFormat = (num) => {
		return `${typeof num === 'number' ? num?.toFixed(2) : '0.00'}`;
	};

	useEffect(() => {
		fetchDownLine();
	}, [timeQuery, status, currentPage, perPage]);

	return (
		<PageWrapper title={dashboardPagesMenu.uplinesummary.text}>
			<Page>
				<div
					style={{ margin: asideStatus || width < 768 ? '' : '0rem 1.5rem' }}
					className='div_founding_container'>
					<div className='fw-bold h3'>{t('txt_finance')}</div>
					<div className='div_found_in_transection mt-3'>
						<div className='fw-bold h5'>{t('txt_financial_report')}</div>
						<div style={{ display: 'flex' }}>
							<Button
								onClick={() => handleRefresh()}
								className='btn_refresh'
								style={{ marginLeft: '8px' }}>
								<BsArrowClockwise size={15} />
								<span>{t('txt_refresh')}</span>
							</Button>
						</div>
					</div>

					<Grid container spacing={2} sx={{ mt: '0.5rem', mb: '2rem' }}>
						<Grid
							item
							xs={12}
							md={12}
							xl={6}
							lg={6}
							className='fundin_date_rang'></Grid>
						<Grid item xs={12} md={12} xl={6} lg={6}>
							<div className='div_search' style={{ justifyContent: 'end' }}>
								<DateRangePicker
									initialSettings={{
										startDate: timeQuery[0],
										endDate: timeQuery[1],
									}}
									onEvent={(e, picker) => handleEvent(e, picker)}
									onCallback={(start, end, label) =>
										handleCallback(start, end, label)
									}>
									<input type='text' className='form-control input_type_date' />
								</DateRangePicker>
							</div>
						</Grid>
						<Grid item xs={12} md={12} xl={12} lg={12}>
							<div>
								<Grid container spacing={1} sx={{ mt: '1rem' }}>
									{dataCard?.map((item) => {
										return (
											<Grid item xs={12} md={12} xl={3} lg={3}>
												<Card
													stretch
													className='card card-stretch-full border border-1 card_dashboard'>
													<CardBody className='d-flex align-items-center'>
														<div className='div_card_sec1'>
															<h4>
																{item?.icon}
																<span className='spn_txt_title_card'>
																	{item?.name}
																</span>
															</h4>
															<NumericFormat
																style={{
																	color: item?.color,
																	fontWeight: 'bold',
																	fontSize: '18px',
																}}
																value={ccyFormat(item?.balance)}
																thousandSeparator
																displayType={'text'}
															/>
														</div>
													</CardBody>
												</Card>
											</Grid>
										);
									})}
								</Grid>
							</div>
						</Grid>
					</Grid>

					<div className='div_filter_found_in'></div>
					{Foundin?.length > 0 ? (
						<>
							<div className='div_table_found_in'>
								<table class='table table-striped'>
									<thead>
										<tr>
											<th scope='col'>{t('txt_create_at')}</th>
											<th scope='col'>{t('txt_amount')}</th>
											<th scope='col'>{t('txt_customer_balance')}</th>
											<th scope='col'>{t('txt_system_balance')}</th>
											<th scope='col'>{t('txt_net_amount')}</th>
										</tr>
									</thead>
									<tbody>
										{Foundin?.map((item, idx) => {
											return (
												<tr key={idx}>
													<th scope='row'>
														{convertDate(item?.createdAt)}
													</th>
													<td>{item?.qty}</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.downline_amount)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.upline_amount)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
													<td>
														<NumericFormat
															value={ccyFormat(item?.amount)}
															thousandSeparator
															displayType={'text'}
														/>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>

								<div className='div_filter_found_in'>
									<CardFooter style={{ overflow: 'scroll' }}>
										<CardFooterLeft>
											<span className='text-muted'>{getInfo()}</span>
										</CardFooterLeft>
										<CardFooterRight className='d-flex'>
											{/* <div
												style={{
													display: 'flex',
													alignItems: 'center',
													textWrap: 'nowrap',
												}}>
												<span>
													{t('txt_amount')} :&nbsp;
													<NumericFormat
														value={ccyFormat(totalAmount?.amount)}
														thousandSeparator
														displayType={'text'}
													/>
													&nbsp;{t('txt_THB')}
												</span>
												<span style={{ marginLeft: '5px' }}>
													{t('txt_total_amount')} :{' '}
													<NumericFormat
														value={ccyFormat(
															totalAmount?.downline_amount,
														)}
														thousandSeparator
														displayType={'text'}
													/>
													&nbsp;{t('txt_THB')}
												</span>
											</div> */}
											{totalPage > 0 && (
												// @ts-ignore
												<Pagination ariaLabel={'xxx'}>
													<PaginationItem
														isFirst
														isDisabled={!(currentPage - 1 > 0)}
														onClick={() => setCurrentPage(1)}
													/>
													<PaginationItem
														isPrev
														isDisabled={!(currentPage - 1 > 0)}
														onClick={() =>
															setCurrentPage(currentPage - 1)
														}
													/>
													{currentPage - 1 > 1 && (
														<PaginationItem
															onClick={() =>
																setCurrentPage(currentPage - 2)
															}>
															...
														</PaginationItem>
													)}
													{pagination()}
													{currentPage + 1 < totalPage && (
														<PaginationItem
															onClick={() =>
																setCurrentPage(currentPage + 2)
															}>
															...
														</PaginationItem>
													)}
													<PaginationItem
														isNext
														isDisabled={!(currentPage + 1 <= totalPage)}
														onClick={() =>
															setCurrentPage(currentPage + 1)
														}
													/>
													<PaginationItem
														isLast
														isDisabled={!(currentPage + 1 <= totalPage)}
														onClick={() => setCurrentPage(totalPage)}
													/>
												</Pagination>
											)}

											<Select
												style={{ width: 'auto' }}
												size='sm'
												ariaLabel='Per'
												onChange={(e) => {
													setPerPage(parseInt(e.target.value, 10));
													setCurrentPage(1);
												}}
												value={perPage.toString()}>
												{Object.keys(PER_COUNT).map((i) => (
													<Option key={i} value={i}>
														{i}
													</Option>
												))}
											</Select>
										</CardFooterRight>
									</CardFooter>
								</div>
							</div>
						</>
					) : (
						<div className='div_list_none fw-bold h5'>
							{t('txt_there_are_no_items')}
						</div>
					)}
				</div>
			</Page>
		</PageWrapper>
	);
}
